module.exports = __webpack_public_path__ + "assets/img/es-43ddcd86.png";